import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { BMapLoader } from '@/utils/bdMap.js';
import { Dialog, Loading, Notify } from 'vant';
import { encryptByAES, decryptByAES } from '@/utils/encrypt.js';
// import BMapLib from '@/utils/GeoUtils.js'
import { transformStr3, handleHttp, getformListItemsdata, getformListItemsdatas, insertStr, setImgsize, formateDate, hoursBetween, getformitemsdata, formfileHandle } from "@/utils/utils";
export default {
  name: 'clockIn',
  meta: {
    title: '打卡'
  },
  components: {},
  data() {
    return {
      team: '',
      teamNumber: '',
      teamtype: '',
      teamtypeId: '',
      name: '',
      time: '',
      introduce: '',
      address: '',
      images: [],
      person: '',
      startTime: '',
      endTime: '',
      hours: '',
      latandlon: '',
      showTeam: false,
      teamcolumns: [],
      teamList: [],
      customFieldName: {
        text: 'title',
        values: 'values'
      },
      showDate: false,
      currentDate: new Date(),
      dateTitle: '',
      datetype: 0,
      dateTime: [],
      imagesNeed: '',
      imagesList: [],
      querys: {},
      BMap: '',
      BDMap: '',
      point: '',
      showMap: false,
      maploading: true,
      mapconfig: {},
      mapaddressType: 1,
      circle: '',
      addressName: ['province', 'city', 'district', 'street', 'street_number', 'streetNumber'],
      addressObj: {},
      showLogin: false,
      hasCode: false,
      mobilePhone: '',
      authCode: '',
      timeNow: 60,
      timeInterval: null,
      museumCode: '',
      imgIndex: 0,
      uplaodImgArr: [],
      limitTimers: {
        flag: false,
        limit: '',
        complete: ''
      },
      clockInform: {
        deptId: this.$route.query.fid,
        formId: '1078859',
        limit: 100,
        page: 1,
        alias: 'tel',
        onlyReturnCount: 1,
        searchStr: {
          filters: [{
            alias: 'tel',
            compt: 'editinput',
            express: '===',
            val: ''
          }, {
            alias: 'updatetime',
            compt: 'editinput',
            express: '===',
            val: ''
          }],
          model: 0
        },
        t: '5c63ca8bb22b57701b796c069e5618d31838e364615b9ea94f1161c5b1664675'
      }
    };
  },
  mounted() {
    this.querys = this.$route.query;
    this.museumCode = this.querys.fid;
    this.getMapconfig();
    let token = localStorage.getItem('token');
    let mobilePhone = localStorage.getItem('mobilePhone');
    if (token && mobilePhone) {
      this.mobilePhone = decryptByAES(mobilePhone);
      this.getUserTeam();
      this.showLogin = false;
      this.clockInform.searchStr.filters[0].val = this.mobilePhone;
      this.clockInform.searchStr.filters[1].val = new Date().toDateString();
      this.clockInform.searchStr = encodeURI(JSON.stringify(this.clockInform.searchStr));
      this.getUserClockIn();
    } else {
      this.showLogin = true;
    }
  },
  watch: {
    timeNow(val) {
      if (val === 0) {
        clearInterval(this.timeInterval);
        this.hasCode = false;
      }
    }
  },
  methods: {
    /*
    ** 获取繁星地图配置表
    */
    getMapconfig() {
      const data = {
        deptId: this.querys.fid,
        formId: 1078666,
        formUserId: this.querys.formUserId,
        t: 'b2363e4419b835ad7848673afb79732383825a93035ae6268d91df56c28f60d9'
      };
      this.$api.getFormDetail(data.deptId, data.formUserId, data.t).then(res => {
        if (res.formUserList.length > 0) {
          let data = {};
          res.formUserList[0].formData.forEach(item => {
            this.mapconfig[transformStr3(item.alias)] = getformitemsdata(item);
          });
          this.mapaddressType = this.mapconfig[14] === '获取当前位置' ? 0 : 1;

          /* 处理限制次数 */
          if (this.mapconfig[10] !== '') {
            this.limitTimers.flag = true;
            this.limitTimers.limit = Number(this.mapconfig[10]);
          }
        }
      });
    },
    /*
    ** 获取用户所属团队列表
    */
    getUserTeam() {
      const data = {
        deptId: this.querys.fid,
        formId: 1059398,
        limit: 100,
        page: 1,
        t: '9a33d3c41cd509eb4794e46c376641d3cb372f5a11d78917d362ce3fb72373ed',
        searchStr: {
          filters: [[{
            alias: '36',
            compt: 'editinput',
            express: '===',
            val: this.mobilePhone
          }], [{
            alias: '8',
            compt: 'editinput',
            express: '===',
            val: this.mobilePhone
          }]],
          model: 1
        }
      };
      data.searchStr = encodeURI(JSON.stringify(data.searchStr));
      this.$api.singleadvanceSearchv2(data).then(res => {
        if (res.totalRow > 0) {
          res.dataList.map((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            this.teamcolumns.push({
              title: itemformat[2],
              codes: itemformat[1]
            });
            return item;
          });
          this.teamList = res.dataList;
        }
      });
    },
    /*
    ** 所属团队确定
    */
    onConfirm(val) {
      this.team = val.title;
      this.teamNumber = val.codes;
      this.teamList.forEach(item => {
        if (item.itemformdata[1] === val.codes) {
          this.teamtype = item.itemformdata[68].length > 0 ? item.itemformdata[68] : '';
          this.teamtypeId = item.itemformdata[69] && item.itemformdata[69].length > 0 ? item.itemformdata[69] : '';
        }
      });
      this.showTeam = false;
    },
    /*
    ** 显示活动时间选择器
    */
    showDatePop(type) {
      this.showDate = true;
      this.datetype = type;
      this.dateTitle = type === 0 ? '活动开始时间' : '活动结束时间';
    },
    /*
    ** 时间选择器确定
    */
    onConfirmdate(val) {
      this.showDate = false;
      let times = new Date(val).getTime();
      if (this.datetype === 0) {
        this.startTime = formateDate(val, 'yyyy-MM-dd hh:mm');
        this.dateTime[0] = times;
      } else {
        this.endTime = formateDate(val, 'yyyy-MM-dd hh:mm');
        this.dateTime[1] = times;
      }
      if (this.dateTime.length === 2 && this.dateTime[0] && this.dateTime[1]) {
        let hours = hoursBetween(this.dateTime[0], this.dateTime[1]);
        this.hours = this.isDecimal(hours) ? hours.toFixed(2) : hours;
      }
    },
    isDecimal(num) {
      return num !== Math.floor(num);
    },
    /*
    ** 加载百度地图
    */
    LoadBdmap() {
      this.showMap = true;
      let that = this;
      this.$nextTick(() => {
        BMapLoader().then(BMap => {
          this.loadScript('./js/GeoUtils.js', () => {});
          this.maploading = false;
          this.BMap = BMap;
          this.BDMap = new BMap.Map('bdcontainer', {
            enableMapClick: false
          });
          let geolocation = new BMap.Geolocation();
          let geoc = new BMap.Geocoder();
          geolocation.getCurrentPosition(a => {
            let latlng = a.point;
            geoc.getLocation(a.point, function (rs) {
              that.addressObj = rs.addressComponents;
              that.point = new BMap.Point(rs.point.lng, rs.point.lat);
              that.latandlon = `${rs.point.lng},${rs.point.lat}`;
              let hasValue = [];
              that.addressName.forEach(child => {
                if (that.addressObj[child] !== undefined && that.addressObj[child] !== '') hasValue.push(that.addressObj[child]);
              });
              that.address = hasValue.join('/');
              that.BDMap.centerAndZoom(that.point, 15);
              that.BDMap.clearOverlays();
              let marker = new BMap.Marker(that.point);
              marker.id = 1;
              that.BDMap.addOverlay(marker);
              if (that.mapaddressType === 0) {
                let radius = that.mapconfig[17] === '不可微调' ? 0 : Number(that.mapconfig[17].match(/\d+/g));
                that.circle = new BMap.Circle(that.point, radius, {
                  fillColor: 'blue',
                  strokeWeight: 1,
                  fillOpacity: 0.3,
                  strokeOpacity: 0.3
                });
                that.BDMap.addOverlay(that.circle);
              }
            });
          });
          this.BDMap.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
          this.BDMap.addEventListener('click', function (e) {
            let point = new BMap.Point(e.latlng.lng, e.latlng.lat);
            // if (that.mapaddressType === 1) return false
            if (that.mapaddressType === 0 && !BMapLib.GeoUtils.isPointInCircle(point, that.circle)) {
              Notify({
                type: 'warning',
                message: '不在区域内，无法打卡'
              });
              return false;
            }
            that.BDMap.getOverlays().forEach(elem => {
              if (elem.id && elem.id === 1) that.BDMap.removeOverlay(elem);
            });
            let pt = e.latlng;
            that.latandlon = `${pt.lng},${pt.lat}`;
            let marker = new BMapGL.Marker(new BMap.Point(pt.lng, pt.lat));
            marker.id = 1;
            that.BDMap.addOverlay(marker);
            geoc.getLocation(pt, function (rs) {
              let addComp = rs.addressComponents;
              that.addressObj = addComp;
              let hasValue = [];
              that.addressName.forEach(child => {
                if (addComp[child] !== undefined && addComp[child] !== '') hasValue.push(addComp[child]);
              });
              that.address = hasValue.join('/');
            });
          });
        });
      });
    },
    /*
    ** 隐藏百度地图
    */
    hideMap() {
      Dialog({
        title: '提示',
        message: '确定要清除定位信息吗？',
        showCancelButton: true,
        teleport: '#sectionWrap'
      }).then(() => {
        // on confirm
        this.BDMap.clearOverlays();
        this.showMap = false;
      }).catch(() => {
        // on cancel
      });
    },
    /*
    ** 文件读取完成后的回调函数
    */
    afterRead(rawFile) {
      console.log(rawFile);
      this.imgIndex++;
      rawFile.id = this.imgIndex;
      rawFile.status = 'uploading';
      rawFile.message = '上传中...';
      let formData = new FormData();
      formData.append('file', rawFile.file);
      this.$api.uploadSingle(formData).then(res => {
        if (res.status === 40101) {
          localStorage.removeItem('mobilePhone');
          localStorage.removeItem('token');
          setTimeout(() => {
            location.reload();
          }, 1000);
          return false;
        }
        res.url = handleHttp(res.http);
        res.id = this.imgIndex;
        rawFile.status = 'done';
        rawFile.message = '';
        this.uplaodImgArr.push(res);
      });
    },
    /*
    ** 删除文件预览时触发
    */
    imagesDelete(file) {},
    /*
    ** 提交
    */
    onSubmit(values) {
      console.log(values);
      let formData = {
        deptId: this.querys.fid,
        formId: 1078859,
        uid: 145444302
      };
      if (new Date(values.endTime).getTime() < new Date(values.startTime).getTime()) {
        Notify({
          type: 'warning',
          message: '活动结束时间需要大于活动开始时间'
        });
        return false;
      }
      if (values.latandlon === '') {
        Notify({
          type: 'warning',
          message: '请选择活动地点'
        });
        return false;
      }
      if (this.imagesList.length === 0) {
        Notify({
          type: 'warning',
          message: '请上传活动图片'
        });
        return false;
      }
      if (this.limitTimers.flag && this.limitTimers.limit === this.limitTimers.complete) {
        Notify({
          type: 'warning',
          message: '今日打卡次数已用完'
        });
        return false;
      }
      let lnglat = values.latandlon.split(',');
      let imgList = [];
      this.imagesList.forEach(item1 => {
        this.uplaodImgArr.forEach(item2 => {
          if (item1.id === item2.id) imgList.push(item2);
        });
      });
      const addData = [{
        "alias": "gameId",
        "compt": "editinput",
        values: [{
          "val": this.teamNumber
        }]
      }, {
        "alias": "team",
        "compt": "selectbox",
        values: [{
          "val": values.team
        }]
      }, {
        "alias": "teamtype",
        "compt": "editinput",
        values: [{
          "val": values.teamtype
        }]
      }, {
        "alias": "name",
        "compt": "editinput",
        values: [{
          "val": values.name
        }]
      }, {
        "alias": "time",
        "compt": "datetimerange",
        values: [{
          "realDateVal": new Date(values.startTime).getTime(),
          "val": values.startTime
        }, {
          "realDateVal": new Date(values.endTime).getTime(),
          "val": values.endTime
        }, {
          "val": values.hours
        }]
      }, {
        "alias": "address",
        "compt": "location",
        values: [{
          "address": values.address,
          "lng": lnglat[0],
          "lat": lnglat[1],
          "street": this.addressObj.street,
          "country": this.addressObj.country,
          "province": this.addressObj.province,
          "city": this.addressObj.city,
          "district": this.addressObj.district,
          "township": this.addressObj.street_number || this.addressObj.streetNumber
        }]
      }, {
        "alias": "images",
        "compt": "imagebox",
        values: formfileHandle(imgList, 'imagebox', formData.uid)
      }, {
        "alias": "latandlon",
        "compt": "editinput",
        values: [{
          "val": values.latandlon
        }]
      }, {
        "alias": "tel",
        "compt": "editinput",
        values: [{
          "val": this.mobilePhone
        }]
      }, {
        "alias": "teamtypeId",
        "compt": "editinput",
        values: [{
          "val": values.teamtypeId
        }]
      }, {
        "alias": "introduce",
        "compt": "edittextarea",
        values: [{
          "val": values.introduce
        }]
      }, {
        "alias": "updatetime",
        "compt": "editinput",
        values: [{
          "val": new Date().toDateString()
        }]
      }, {
        "alias": "datetime",
        "compt": "numberinput",
        values: [{
          "val": new Date().getTime()
        }]
      }];
      this.$api.addFormdata(formData, encodeURI(JSON.stringify(addData))).then(res => {
        // console.log(res)
        Notify({
          message: '提交成功',
          type: 'success'
        });
        setTimeout(() => {
          location.reload();
        }, 1000);
      });
    },
    loginsubmit(values) {
      this.$api.membertoken(values).then(res => {
        this.showLogin = false;
        localStorage.setItem('mobilePhone', encryptByAES(this.mobilePhone));
        localStorage.setItem('token', res);
        this.getUserTeam();
        this.clockInform.searchStr.filters[0].val = this.mobilePhone;
        this.clockInform.searchStr.filters[1].val = new Date().toDateString();
        this.clockInform.searchStr = encodeURI(JSON.stringify(this.clockInform.searchStr));
        this.getUserClockIn();
      });
    },
    getUserClockIn() {
      let that = this;
      this.$api.singleadvanceSearchv2(this.clockInform).then(res => {
        this.limitTimers.complete = res.totalRow;
      });
    },
    getCode() {
      if (this.hasCode) return false;
      if (this.mobilePhone == '') {
        Notify({
          type: 'warning',
          message: '请输入手机号'
        });
        return false;
      }
      const pMatch = /^1[3456789]\d{9}$/;
      if (!pMatch.test(this.mobilePhone)) {
        Notify({
          type: 'warning',
          message: '手机号码格式错误'
        });
        return false;
      }
      this.$api.getVerificationCode(this.mobilePhone).then(res => {
        if (res) {
          Notify({
            type: 'success',
            message: res
          });
          this.hasCode = true;
          this.timeGo();
        }
      });
    },
    timeGo() {
      this.timeNow = 60;
      this.timeInterval = setInterval(() => {
        this.timeNow--;
      }, 1000);
    },
    loadScript(url, callback) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      if (script.readyState) {
        // IE
        script.onreadystatechange = function () {
          if (script.readyState == 'loaded' || script.readyState == 'complete') {
            script.onreadystatechange = null;
            callback();
          }
        };
      } else {
        // Others
        script.onload = function () {
          callback();
        };
      }
      script.src = url;
      document.getElementsByTagName('head')[0].appendChild(script);
    }
  }
};